import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import store from './store'
import jQuery from 'jquery'
import VueXlsx from 'vue-js-xlsx'
import VueMask from 'v-mask'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/tr-TR'
import VueApexCharts from 'vue-apexcharts'


global.jQuery = jQuery;
global.$ = jQuery;

Vue.use(VueXlsx);
Vue.use(ElementUI, {locale});
Vue.use(VueMask);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

import 'jquery/dist/jquery.min'

new Vue({
  el: '#app',
  router,
  store,
  VueMask,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js